import { render } from "./Langganan.vue?vue&type=template&id=8444b05a&scoped=true"
import script from "./Langganan.vue?vue&type=script&lang=js"
export * from "./Langganan.vue?vue&type=script&lang=js"

import "./Langganan.vue?vue&type=style&index=0&id=8444b05a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8444b05a"]])

export default __exports__